// Single registry of supported languages. Adding one = an entry here +
// src/locales/<code>.json (+ optionally prompts/<code>/).
export const LANGUAGES = [
  { code: 'it', name: 'Italiano', englishName: 'Italian', dateLocale: 'it-IT' },
  { code: 'en', name: 'English', englishName: 'English', dateLocale: 'en-GB' },
];
export const DEFAULT_LANG = 'en';
export const isSupported = (code) => LANGUAGES.some((l) => l.code === code);
export const getLanguage = (code) =>
  LANGUAGES.find((l) => l.code === code) || LANGUAGES.find((l) => l.code === DEFAULT_LANG);
